import { useEffect } from 'react';
import { useBreakpoint } from './useBreakpoint';

export function useKeyboardOffset() {
  const breakpoint = useBreakpoint();

  useEffect(() => {
    if (breakpoint !== 'mobile' || !window.visualViewport) return;

    const handleResize = () => {
      const offset = window.innerHeight - window.visualViewport.height;
      document.documentElement.style.setProperty(
        '--keyboard-offset', `${Math.max(0, offset)}px`
      );
    };

    window.visualViewport.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('scroll', handleResize);

    return () => {
      window.visualViewport.removeEventListener('resize', handleResize);
      window.visualViewport.removeEventListener('scroll', handleResize);
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
    };
  }, [breakpoint]);
}
